import React from 'react';
import Layout from '../components/common/Layout/Layout';

const DefaultLayout = ({ component }) => {
  return <Layout>{component}</Layout>;
};

export default DefaultLayout;
